import { render, staticRenderFns } from "./SwitchPack.vue?vue&type=template&id=69510984"
import script from "./SwitchPack.vue?vue&type=script&lang=js"
export * from "./SwitchPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports